import VideoLessons from './features/VideoLessons'
import Documents from './features/Documents'
import Consultancy from './features/Consultancy'

const textVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
}

export default function Features() {
  return (
    <section
      id="a-plataforma"
      className="w-full bg-surface-section-alt py-16 md:py-24 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 w-full flex flex-col space-y-16 md:space-y-32">
        <VideoLessons textVariants={textVariants} />
        <Documents textVariants={textVariants} />
        <Consultancy textVariants={textVariants} />
      </div>
    </section>
  )
}
